var map = {
	"./en_US.json": [
		559,
		70
	],
	"./es_ES.json": [
		560,
		71
	],
	"./in_ID.json": [
		561,
		72
	],
	"./ru_RU.json": [
		562,
		73
	],
	"./th_TH.json": [
		563,
		74
	],
	"./zh_CN.json": [
		564,
		75
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 460;
module.exports = webpackAsyncContext;